module.exports = __webpack_public_path__ + "989819df2885fcee66eb43159759d8af.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/group-16.png
// module id = 690
// module chunks = 0